module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/fitsize//red_3.png?v=16226bb8";